export interface ParcoursState {
  paginator: { pageNb: number; pageSize: number };
}

export const initialState: ParcoursState = {
  paginator: { pageNb: 1, pageSize: 20 },
};
